import { useTranslation } from 'react-i18next';

type Props = {
    addressKind: 'anschrift' | 'vorherigeAnschrift';
};

const Headers: React.FC<Props> = ({ addressKind }) => {
    const { t } = useTranslation();
    const title =
        addressKind === 'anschrift' ? 'LIVING_SITUATION_DATA.ADDRESS' : 'LIVING_SITUATION_DATA.PREVIOUS_ADDRESS';

    return <p className="flex h-8 items-center text-sm font-bold text-midnight">{t(title)}</p>;
};

export default Headers;
